import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=de76c02e&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
import style0 from "./Terms.vue?vue&type=style&index=0&id=de76c02e&prod&lang=scss&scoped=true"
import style1 from "./Terms.vue?vue&type=style&index=1&id=de76c02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de76c02e",
  null
  
)

export default component.exports